/*eslint-disable*/ export const messages = JSON.parse("{\"textarea.label.optional\":[\"Valgfri\"]}");
//# sourceMappingURL=messages.mjs.map